module.exports = __webpack_public_path__ + "static/trip-c116f0113957e80e5be6a9c70e574637.jpg";